<mat-card *ngIf="resumen">
  <mat-card-header>
    <mat-card-title>RENTA PRIVADA</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="card-grid">
      <div class="dato-mini poliza-numero">
        <div class="label">Número de póliza</div>
        <div class="value">{{ resumen.Numero }}</div>
      </div>
      <div class="lseparator hidden-on-ie"></div>

      <div class="poliza-nombre poliza-acumulado-title">
        RENTA VITALICIA PRIVADA
      </div>
      <div class="dato-mini div-rut">
        <div class="label">Rut</div>
        <div class="value">{{ formatRUT(resumen.Rut) }}</div>
      </div>
      <div class="dato-mini div-nombre">
        <div class="label">Nombre</div>
        <div class="value">
          {{ resumen.Nombre }} {{ resumen.ApellidoPaterno }}
        </div>
      </div>
      <div class="rseparator hidden-on-ie"></div>

      <div class="container-button">
        <app-button-ver-mas
          class="button-ver-privada"
          (click)="viewDetail(resumen.Poliza, resumen.NombreProducto)"
        >
        </app-button-ver-mas>
      </div>
    </div>
  </mat-card-content>
</mat-card>
